import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, OnDestroy, OnInit, ViewChild, HostBinding } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange, MatTreeNestedDataSource } from '@angular/material';
import { Element, ElementsService, CurrentService, IDept, IElement } from 'dbweb-core';
import { Subscription, forkJoin } from 'rxjs';
import { debounceTime, startWith } from 'rxjs/operators';
import { BillComponent } from '../bill/bill.component';
import { RoleEle, RoleBack, RoleValidElement } from './back';
import { TreeNode } from './tree-node';

class ValidElement extends Element {
	Dept: String;
	constructor(data: RoleValidElement) {
		super({ ...data, NotMenu: true, URL: '' });
		this.Dept = data.Dept;
	}
}
@Component({
	selector: 'common-role',
	templateUrl: './role.component.html',
	styleUrls: ['./role.component.scss'],
	providers: [RoleBack]
})
export class RoleComponent implements OnInit, OnDestroy {
	readonly menuSelectAll = 'all';
	readonly menuSelectChecked = 'checked';
	readonly menuSelectNotChecked = 'not-checked';
	@HostBinding('class.c-role') hostClass = true;
	@ViewChild('bill', { static: true })
	bill: BillComponent;
	ctrlElementName = new FormControl();
	ctrlMenuRange = new FormControl();
	filterElements: ValidElement[];
	private subs: Subscription[] = [];
	rootNode: TreeNode;
	treeControl = new NestedTreeControl<TreeNode>(node => node.children);
	dataSource = new MatTreeNestedDataSource<TreeNode>();
	validElements: ValidElement[];
	ctrlDeptSelect = new FormControl();
	hasRoleDepts: IDept[];
	constructor(public eles: ElementsService, private back: RoleBack, public current: CurrentService) {}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}
	refreshFilterElements() {
		const val = this.ctrlElementName.value || '';
		const selectRange = this.ctrlMenuRange.value;
		const selectDepts = this.ctrlDeptSelect.value as IDept[];
		this.filterElements = this.validElements.filter(v => v.title().includes(val) || v.Category.includes(val));
		switch (selectRange) {
			case this.menuSelectChecked:
				this.filterElements = this.filterElements.filter(
					v => this.roles.find(sv => sv.EleName === v.Name) !== undefined
				);
				break;
			case this.menuSelectNotChecked:
				this.filterElements = this.filterElements.filter(
					v => this.roles.find(sv => sv.EleName === v.Name) === undefined
				);
				break;
		}
		// è¿æ»¤é¨é¨ä»£ç 
		this.filterElements = this.filterElements.filter(v => selectDepts.find(sv => sv.Code === v.Dept));
		this.filterElements = this.filterElements.sort((a, b) => a.title().localeCompare(b.title()));
		this.rootNode = new TreeNode('root', null);
		this.filterElements.forEach(v => {
			this.rootNode.forceCreate([...v.Category.split('/'), v.Label || v.Name], v);
		});
		this.dataSource.data = this.rootNode.children;
		this.treeControl.dataNodes = this.rootNode.children;
		// ç¶æä¿å­ä¸ä½ï¼æ»æ¯ç¼©èµ·ï¼æä»¥æ¯æ¬¡å¨å±å¼
		this.treeControl.expandAll();
	}
	ngOnInit() {
		this.subs.push(
			this.bill.init.subscribe(() => {
				this.bill.typeRecord.Eles = this.bill.typeRecord.Eles || [];
				// æ°å¢æç¼è¾ï¼å°æ¾ç¤ºææçèåé¡¹ï¼å¦ååªæ¾ç¤ºå·²ç»éä¸­ç
				if (this.bill.isAdd() || this.bill.isEdit()) {
					this.ctrlMenuRange.patchValue(this.menuSelectAll);
				} else {
					this.ctrlMenuRange.patchValue(this.menuSelectChecked);
				}
				this.subs.push(
					this.current.change$.subscribe(() => {
						this.back.fetchHasRoleDepts().subscribe(depts => {
							this.hasRoleDepts = depts;
							this.ctrlDeptSelect.patchValue(depts);
						});

						this.back.fetchEles().subscribe(v => {
							// è½¬æ¢æElementï¼ä¸»è¦ç®çæ¯ç¨å°å®çtitleå½æ°
							this.validElements = v.map(sv => new ValidElement(sv));
							this.subs.push(
								this.ctrlElementName.valueChanges
									.pipe(startWith(''), debounceTime(500))
									.subscribe(() => this.refreshFilterElements()),
								this.ctrlMenuRange.valueChanges.subscribe(() => this.refreshFilterElements()),
								this.ctrlDeptSelect.valueChanges.subscribe(() => this.refreshFilterElements())
							);
						});
					})
				);
			})
		);
	}
	get roles(): RoleEle[] {
		return this.bill.typeRecord.Eles as RoleEle[];
	}
	hasChild = (_: number, node: TreeNode) => !!node.children && node.children.length > 0;
	treeNodeChecked(node: TreeNode): boolean {
		if (node.ele) {
			return this.roles.find(v => v.EleName === node.ele.Name) !== undefined;
		} else {
			const foundNotChecked = node.children.find(v => !this.treeNodeChecked(v));
			return foundNotChecked === undefined;
		}
	}
	changeNodeChecked(node: TreeNode, event: MatCheckboxChange) {
		if (event.checked) {
			if (node.ele) {
				if (!this.roles.find(v => v.EleName === node.ele.Name)) {
					this.roles.push({ EleName: node.ele.Name, RoleName: this.bill.formGroup.get('Name').value });
				}
			}
		} else {
			if (node.ele) {
				const idx = this.roles.findIndex(v => v.EleName === node.ele.Name);
				if (idx > -1) {
					this.roles.splice(idx, 1);
				}
			}
		}
		node.children.forEach(v => this.changeNodeChecked(v, event));
	}
	dropEle(ele: RoleEle) {
		const idx = this.roles.findIndex(v => v.EleName === ele.EleName);
		if (idx > -1) {
			this.roles.splice(idx, 1);
		}
	}
}
